export const Field = {
  INPUT: 'INPUT',
  OUTPUT: 'OUTPUT',
}
